/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    MenuItem,
    Select,
    Button,
    Grid,
    Typography,
    Chip,
    Divider,
    Paper,
    LinearProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
    ListItemText,
    Tooltip,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import RejectReasonModal from "../../Modals/rejectReason";
import AddIcon from '@mui/icons-material/Add';
import GetAppIcon from '@mui/icons-material/GetApp';
import IosShareIcon from '@mui/icons-material/IosShare';
import TagIcon from "@mui/icons-material/Tag";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import SwitchToggle from "../../components/SwitchToggle";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StarIcon from "@mui/icons-material/Star";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import CallSplitIcon from "@mui/icons-material/CallSplit";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import WebAssetOutlinedIcon from "@mui/icons-material/WebAssetOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import ReportIcon from "@mui/icons-material/Report";
import LifecycleOverview from "../../Modals/lifecycle_overview";
import ViewSPHealthScores from "../../Modals/viewSPHealthScores";
import BulkNotify from "../../Modals/bulkNotify";

import {
    BarChart,
    Bar,
    LineChart,
    Line,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
} from "recharts";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const ManageServiceProviders = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [selected, setSelected] = useState<string[]>([]);
    const toggleSelect = (id: string) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const [valueTabs1, setValueTabs1] = useState(0);
    const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs1(newValue);
    };

    const [impactModalOpen, setImpactModalOpen] = useState(false);
    const [selectedServiceForImpact, setSelectedServiceForImpact] = useState<any>(null);

    const [openHealthModal, setOpenHealthModal] = useState(false);
    const [selectedProviderForHealth, setSelectedProviderForHealth] = useState<any>(null);


    const serviceProviderColumns = [
        "Select",
        "Service Provider",
        "Contact",
        "Service Type",
        "Status",
        "Health Score",
        "Revenue",
        "Suspend",
        "Actions",
    ];
    const [serviceProviderData, setServiceProviderData] = useState([
        {
            id: "SP-001",
            name: "PixelCraft Studios",
            email: "hello@pixelcraft.ae",
            phone: "+971501234567",
            type: "Product Photography",
            status: "Active",
            health: 94.2,
            revenue: "AED 320,000",
            suspended: false,
        },
        {
            id: "SP-002",
            name: "DesignSphere",
            email: "contact@designsphere.ae",
            phone: "+971502345678",
            type: "Graphic & UI Design",
            status: "Active",
            health: 81.6,
            revenue: "AED 210,500",
            suspended: false,
        },
        {
            id: "SP-003",
            name: "MotionHive",
            email: "projects@motionhive.ae",
            phone: "+971503456789",
            type: "Video Editing",
            status: "Inactive",
            health: 72.4,
            revenue: "AED 145,000",
            suspended: true,
        },
    ]);


    const applicationColumns = [
        "Select",
        "Business Details",
        "Provider Details",
        "Category",
        "Type",
        "Risk",
        "Quality",
        "Compliance",
        "Revenue Potential",
        "Pending Duration",
        "Application Status",
        "Applied On",
        "Actions",
    ];

    const [visibleApplicationColumns, setVisibleApplicationColumns] = useState<string[]>(applicationColumns);
    const [expandedRow, setExpandedRow] = useState<string | null>(null);
    const toggleExpand = (id: string) => {
        setExpandedRow((prev) => (prev === id ? null : id));
    };

    const performanceColumns = [
        "Provider Details",
        "Business Details",
        "Period",
        "Service Requests",
        "Completed",
        "GMV",
        "Commission",
        "Net to Provider",
        "Revenue",
        "Rating",
        "On-Time %",
        "Health",
        "AI Insights",
        "Actions",
    ];

    const productColumns = [
        "Product",
        "Vendor",
        "Category",
        "Price",
        "Stock",
        "Sales",
        "Stock Availability",
        "Status",
        "Recommended AI Action",
        "Actions"
    ];

    const [selectedExportFields, setSelectedExportFields] = useState<string[]>([]);
    const exportFields = [
        "Provider Details",
        "Business Details",
        "Category",
        "Service Type",
        "Risk Score",
        "Quality Score",
        "Compliance",
        "Revenue Potential",
        "Pending Duration",
        "Application Status",
        "Total Requests",
        "Completed Tasks",
        "GMV",
        "Commission",
        "Net to Provider",
        "Revenue",
        "Rating",
        "On-Time %",
        "Health",
        "Status",
        "Onboarding Date",
        "Last Order"
    ];

    const [bulkSPExportData, setBulkSPExportData] = useState([
        {
            id: "SP-001",
            providerName: "PixelCraft Studios",
            businessName: "PixelCraft Studios L.L.C",
            email: "hello@pixelcraft.ae",
            phone: "+971501234567",
            category: "Media",
            serviceType: "Product Photography",
            riskScore: 18,
            qualityScore: 92,
            compliance: "Ready",
            revenuePotential: "High",
            pendingDuration: 2,
            applicationStatus: "Approved",
            totalRequests: 42,
            completedTasks: 39,
            gmv: "AED 96,000",
            commission: "AED 9,500",
            netToProvider: "AED 86,500",
            revenue: "AED 9,500",
            rating: 4.8,
            onTime: 94,
            health: 91,
            status: "Active",
            onboardingDate: "12 Sep 2024",
            lastOrder: "05-01-2026",
            suspended: false,
        },
        {
            id: "SP-002",
            providerName: "DesignSphere",
            businessName: "DesignSphere FZCO",
            email: "contact@designsphere.ae",
            phone: "+971502345678",
            category: "Design",
            serviceType: "Graphic & UI Design",
            riskScore: 45,
            qualityScore: 78,
            compliance: "Missing VAT",
            revenuePotential: "Medium",
            pendingDuration: 8,
            applicationStatus: "Needs Info",
            totalRequests: 31,
            completedTasks: 26,
            gmv: "AED 60,000",
            commission: "AED 5,800",
            netToProvider: "AED 54,200",
            revenue: "AED 5,800",
            rating: 4.3,
            onTime: 87,
            health: 78,
            status: "Active",
            onboardingDate: "14 Sep 2024",
            lastOrder: "02-01-2026",
            suspended: false,
        },
    ]);
    const productData = [
        {
            id: 1,
            productId: "SKU-1001",
            productName: "Sports Zone Jacket",
            vendorName: "Sports Zone",
            category: "Fashion",
            price: 149.99,
            stock: 8,
            sales: 0,
            status: "low_stock",
            aiaction: "Accept"
        },
        {
            id: 2,
            productId: "SKU-1002",
            productName: "Beauty Glow Serum",
            vendorName: "Beauty Place",
            category: "Beauty",
            price: 89.5,
            stock: 42,
            aiaction: "Reject",

            sales: 0,
            status: "active"
        },
        {
            id: 3,
            productId: "SKU-1003",
            productName: "Home Essentials Lamp",
            vendorName: "Home Essentials",
            category: "Home & Living",
            price: 199.0,
            stock: 3,
            sales: 0,
            aiaction: "Accept",
            status: "low_stock"
        },
        {
            id: 4,
            productId: "SKU-1004",
            productName: "TechGadgets Wireless Earbuds",
            vendorName: "TechGadgets UAE",
            category: "Electronics",
            price: 249.99,
            stock: 55,
            aiaction: "Reject",

            sales: 0,
            status: "active"
        },
        {
            id: 5,
            productId: "SKU-1005",
            productName: "Fashion House Dress",
            vendorName: "Fashion House Dubai",
            category: "Fashion",
            price: 329.0,
            stock: 12,
            aiaction: "Accept",

            sales: 0,
            status: "active"
        },
        {
            id: 6,
            productId: "SKU-1006",
            productName: "Kitchen Pro Blender",
            vendorName: "Home Essentials",
            category: "Kitchen",
            price: 399.0,
            stock: 6,
            aiaction: "Reject",

            sales: 0,
            status: "low_stock"
        },
        {
            id: 7,
            productId: "SKU-1007",
            productName: "Luxury Skincare Kit",
            vendorName: "Beauty Place",
            category: "Beauty",
            price: 499.99,
            stock: 28,
            aiaction: "Reject",

            sales: 0,
            status: "active"
        },
        {
            id: 8,
            productId: "SKU-1008",
            productName: "Smart Fitness Watch",
            vendorName: "TechGadgets UAE",
            category: "Electronics",
            aiaction: "Accept",

            price: 699.0,
            stock: 4,
            sales: 0,
            status: "low_stock"
        },
        {
            id: 9,
            productId: "SKU-1009",
            productName: "Office Comfort Chair",
            vendorName: "Home Essentials",
            category: "Furniture",
            price: 899.0,
            stock: 15,
            aiaction: "Reject",

            sales: 0,
            status: "active"
        },
        {
            id: 10,
            productId: "SKU-1010",
            productName: "Men's Running Shoes",
            vendorName: "Sports Zone",
            category: "Footwear",
            price: 279.0,
            stock: 9,
            aiaction: "Reject",

            sales: 0,
            status: "low_stock"
        },
        {
            id: 11,
            productId: "SKU-1011",
            productName: "Women Handbag Classic",
            vendorName: "Fashion House Dubai",
            category: "Accessories",
            price: 359.0,
            stock: 18,
            aiaction: "Accept",

            sales: 0,
            status: "active"
        },
        {
            id: 12,
            productId: "SKU-1012",
            productName: "Air Purifier Plus",
            vendorName: "TechGadgets UAE",
            category: "Home Appliances",
            price: 799.0,
            stock: 2,
            aiaction: "Reject",
            sales: 0,
            status: "low_stock"
        }
    ];

    const totalProducts = productData.length;

    const activeProducts = productData.filter(
        (p) => p.status === "active"
    ).length;

    const outOfStock = productData.filter(
        (p) => p.stock === 0
    ).length;

    const lowStock = productData.filter(
        (p) => p.stock > 0 && p.stock < 10
    ).length;

    const HealthBar = ({ value, onClick }: { value: number, onClick?: () => void }) => {
        const color =
            value >= 85 ? "#22c55e" : value >= 70 ? "#f59e0b" : "#ef4444";

        return (
            <div className="health_bar" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
                <span style={{ background: color, width: `${value}%` }} />
                <small>{value}</small>
            </div>
        );
    };


    const [open, setOpen] = useState(false);
    const handleCloseModal = () => {
        setOpen(false);
    };
    const [open1, setOpen1] = useState(false);
    const handleCloseModal1 = () => {
        setOpen1(false);
    };
    const [openNotify, setOpenNotify] = useState(false);
    const handleCloseNotify = () => {
        setOpenNotify(false);
    };
    const payoutColumns = [
        "Payout ID",
        "Service Provider",
        "Period",
        "Bookings",
        "Gross Sales",
        "Commission",
        "Net Amount",
        "Status",
        "Actions",
    ];
    const payoutData = [
        {
            id: "PAY-000010",
            method: "Bank Transfer",
            vendor: "Sports Zone",
            period: "11/11/2025 - 12/10/2025",
            orders: 28,
            gross: "53,949.56",
            commission: "4,620.80",
            net: "49,328.76",
            status: "Pending",
        },
        {
            id: "PAY-000002",
            method: "Bank Transfer",
            vendor: "TechGadgets UAE",
            period: "11/11/2025 - 12/10/2025",
            orders: 72,
            gross: "30,257.03",
            commission: "2,589.59",
            net: "27,667.44",
            status: "Completed",
        },
        {
            id: "PAY-000003",
            method: "Bank Transfer",
            vendor: "Home Essentials",
            period: "11/11/2025 - 12/10/2025",
            orders: 24,
            gross: "39,869.25",
            commission: "4,130.84",
            net: "35,738.41",
            status: "Completed",
        },
    ];
    const segmentData = [
        {
            title: "High-Value Service Providers",
            type: "Dynamic",
            description: "Service Providers with lifetime value > AED 5000",
            count: 850,
            status: "Active",
            icon: "💎",
        },
        {
            title: "Cart Abandoners",
            type: "Dynamic",
            description: "Service Providers with abandoned carts",
            count: 1540,
            status: "Active",
            icon: "🛒",
        },
        {
            title: "UAE Service Providers",
            type: "Static",
            description: "Service Providers based in UAE",
            count: 12500,
            status: "Active",
            icon: "🇦🇪",
        },
        {
            title: "Fashion Service Providers",
            type: "Dynamic",
            description: "Fashion category Service Providers",
            count: 5600,
            status: "Active",
            icon: "👗",
        },
        {
            title: "New Signups",
            type: "Dynamic",
            description: "Recently registered Service Providers",
            count: 890,
            status: "Active",
            icon: "✨",
        },
        {
            title: "Lapsed Service Providers",
            type: "Predictive",
            description: "Inactive Service Providers",
            count: 2300,
            status: "Active",
            icon: "⚠️",
        },
    ];
    const serviceProviderApplicationData = [
        {
            id: "SP-APP-001",
            name: "PixelCraft Studios",
            email: "hello@pixelcraft.ae",
            phone: "+971501234567",
            category: "Media",
            serviceType: "Product Photography",
            riskScore: 18,
            qualityScore: 92,
            complianceReady: true,
            revenuePotential: "High",
            pendingDays: 2,
            applicationtype: "New Service Provider",
            appliedOn: "12 Sep 2024",
        },
        {
            id: "SP-APP-002",
            name: "DesignSphere",
            email: "contact@designsphere.ae",
            phone: "+971502345678",
            category: "Design",
            serviceType: "Graphic & UI Design",
            riskScore: 45,
            qualityScore: 78,
            complianceReady: false,
            revenuePotential: "Medium",
            pendingDays: 8,
            applicationtype: "New Service Provider",
            appliedOn: "14 Sep 2024",
        },
        {
            id: "SP-APP-003",
            name: "MotionHive",
            email: "projects@motionhive.ae",
            phone: "+971503456789",
            category: "Media",
            serviceType: "Video Editing",
            riskScore: 12,
            qualityScore: 88,
            complianceReady: true,
            revenuePotential: "High",
            pendingDays: 1,
            applicationtype: "Category Addition",
            appliedOn: "18 Sep 2024",
        },
    ];

    const serviceProviderPerformanceData = [
        {
            id: "SP-001",
            name: "PixelCraft Studios",
            businessName: "PixelCraft Studios L.L.C",
            email: "hello@pixelcraft.ae",
            phone: "+971501234567",
            type: "Media",
            periodStart: "01 Sep 2024",
            periodEnd: "30 Sep 2024",
            totalJobs: 42,
            completedJobs: 39,
            gmv: "AED 96,000",
            commission: "AED 9,500",
            netToProvider: "AED 86,500",
            revenue: "AED 9,500",
            rating: 4.8,
            onTime: 94,
            health: 91,
            aiInsight: "Consistent high quality. Recommend preferred status.",
            performanceBreakdown: {
                completed: { delivered: 39, cancelled: 2, returned: 1 },
                gmv: { products: "AED 90,000", shipping: "AED 6,000", vat: "AED 0" },
                commission: { base: "AED 9,000", adjust: "AED 500" },
                revenue: { base: "AED 9,500", ads: "AED 0" },
                onTime: { early: "40%", justInTime: "54%", delayed: "6%" },
            },
        },
        {
            id: "SP-002",
            name: "DesignSphere",
            businessName: "DesignSphere FZCO",
            email: "contact@designsphere.ae",
            phone: "+971502345678",
            type: "Design",
            periodStart: "01 Sep 2024",
            periodEnd: "30 Sep 2024",
            totalJobs: 31,
            completedJobs: 26,
            gmv: "AED 60,000",
            commission: "AED 5,800",
            netToProvider: "AED 54,200",
            revenue: "AED 5,800",
            rating: 4.3,
            onTime: 87,
            health: 78,
            aiInsight: "Delivery delays increased. Monitor performance.",
            performanceBreakdown: {
                completed: { delivered: 26, cancelled: 4, returned: 1 },
                gmv: { products: "AED 58,000", shipping: "AED 2,000", vat: "AED 0" },
                commission: { base: "AED 5,500", adjust: "AED 300" },
                revenue: { base: "AED 5,800", ads: "AED 0" },
                onTime: { early: "30%", justInTime: "57%", delayed: "13%" },
            },
        },
        {
            id: "SP-003",
            name: "MotionHive",
            businessName: "MotionHive",
            email: "projects@motionhive.ae",
            phone: "+971503456789",
            type: "Media",
            periodStart: "01 Sep 2024",
            periodEnd: "30 Sep 2024",
            totalJobs: 18,
            completedJobs: 14,
            gmv: "AED 32,500",
            commission: "AED 3,500",
            netToProvider: "AED 29,000",
            revenue: "AED 3,500",
            rating: 4.1,
            onTime: 82,
            health: 71,
            aiInsight: "High cancellation rate this period.",
            aiRecommendation: {
                action: "Request PIP",
                reason: "Health < 75",
            },
            performanceBreakdown: {
                completed: { delivered: 14, cancelled: 3, returned: 1 },
                gmv: { products: "AED 30,000", shipping: "AED 2,500", vat: "AED 0" },
                commission: { base: "AED 3,500", adjust: "AED 0" },
                revenue: { base: "AED 3,500", ads: "AED 0" },
                onTime: { early: "20%", justInTime: "62%", delayed: "18%" },
            },
        },
    ];
    const serviceData = [
        {
            name: "House Cleaning",
            category: "Home Services",
            subCategory: "Cleaning",
            price: "25",
            unit: "hourly",
            duration: "2 hours",
            status: "Active",
            bookings: 150,
            recommendation: { type: "positive", label: "Promote Service", insight: "High booking volume (150), strong completion rate" },
            trend: { direction: "up", value: "18", label: "MoM" },
            benchmark: "Top 25% in Home Services",
            healthScore: 92,
            priceInsight: { type: "increase", text: "12% below market average — opportunity to increase price" },
            impact: { revenue: "38%", bookings: 12 },
            autoChecks: { category: true, pricing: true, description: true },
            riskLevel: "Low"
        },
        {
            name: "AC Repair",
            category: "Appliance Repair",
            subCategory: "Air Conditioner",
            price: "100",
            unit: "fixed",
            duration: "N/A",
            status: "Inactive",
            bookings: 45,
            recommendation: { type: "warning", label: "Optimize Pricing", insight: "Demand steady but price above category median" },
            trend: { direction: "down", value: "12", label: "MoM" },
            benchmark: "Top 25% in Appliance Repair",
            healthScore: 68,
            alert: "Bookings dropped 40% in 14 days",
            priceInsight: { type: "decrease", text: "Priced 20% higher than similar services — bookings declining" },
            inactivityReason: "Manual admin action",
            recoverySuggestion: "Enable seasonal pricing",
            impact: { revenue: "15%", bookings: 4 },
            autoChecks: { category: true, pricing: false, description: true },
            riskLevel: "Medium"
        },
        {
            name: "Personal Training",
            category: "Health & Fitness",
            subCategory: "Fitness",
            price: "300",
            unit: "package",
            duration: "1 Month",
            status: "Inactive",
            bookings: 30,
            recommendation: { type: "danger", label: "Deactivate / Review", insight: "Low bookings + poor ratings last 30 days" },
            trend: { direction: "down", value: "25", label: "MoM" },
            benchmark: "Bottom 10% in Health & Fitness",
            healthScore: 45,
            priceInsight: { type: "neutral", text: "Price aligns with premium segment but loyalty is low" },
            inactivityReason: "Provider paused",
            recoverySuggestion: "Bundle with related services",
            impact: { revenue: "5%", bookings: 0 },
            autoChecks: { category: true, pricing: true, description: false },
            riskLevel: "High"
        },
    ];


    const topCustomersData = [
        { name: "Sara Ahmed", amount: 18750, tier: "Platinum" },
        { name: "Faisal Hamad", amount: 16800, tier: "Platinum" },
        { name: "Mariam Yousef", amount: 14200, tier: "Gold" },
        { name: "Amina Farid", amount: 13500, tier: "Gold" },
    ];
    const tierData = [
        { name: "Gold", value: 44 },
        { name: "Silver", value: 36 },
        { name: "Bronze", value: 12 },
        { name: "Platinum", value: 8 },
    ];
    const COLORS = ["#d3b88c", "#cfcfcf", "#cd7f32", "#e5e4e2"];


    return (
        <>
            {/* Tabs Section */}
            <Box className="custom_tabs">
                <Tabs
                    value={valueTabs1}
                    onChange={handleChangeTabs1}
                    className="custom_tabs_links"
                >
                    <Tab label="All Service Providers" {...a11yProps(0)} />
                    <Tab label="Service Provider Applications" {...a11yProps(1)} />

                    <Tab label="Performance" {...a11yProps(2)} />
                    <Tab label="Services" {...a11yProps(3)} />
                    <Tab label="Payouts" {...a11yProps(4)} />
                    {/* <Tab label="Service Provider Segments" {...a11yProps(5)} /> */}
                    <Tab label="Service Provider Analytics" {...a11yProps(5)} />
                    <Tab label="Bulk Export" {...a11yProps(6)} />
                </Tabs>

            </Box>
            <CustomTabPanel value={valueTabs1} index={0}>
                <div className="main_title">
                    <h1>Manage Service Providers</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Service Providers
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* NEW VENDORS */}
                    <a href="/manage-customers?filter=new" className="cards">
                        <div className="data_top">
                            <h2>
                                56
                                <p>New Service Providers</p>
                            </h2>
                            <figure className="active_order">
                                <PersonAddAltIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>▲ +12%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* ACTIVE VENDORS */}
                    <a href="/manage-customers?filter=active" className="cards">
                        <div className="data_top">
                            <h2>
                                1,120
                                <p>Active Service Providers</p>
                            </h2>
                            <figure className="sucess">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>84.0%</span>
                            <small>of total Service Providers</small>
                        </div>
                    </a>

                    {/* INACTIVE VENDORS */}
                    <a href="/manage-customers?filter=inactive" className="cards">
                        <div className="data_top">
                            <h2>
                                125
                                <p>Inactive Service Providers</p>
                            </h2>
                            <figure className="danger">
                                <BlockIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>▼ -6%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* PENDING APPROVAL */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                92
                                <p>Pending Approval Service Providers</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>▲ +8%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* TOTAL VENDORS */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                1,301
                                <p>Total Service Providers</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>100%</span>
                            <small>service provider base</small>
                        </div>
                    </a>

                </div>
                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards ">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search SPs..."
                                        />
                                    </Box>
                                    <div className="form">
                                        <div className="control_group">
                                            <input type="date" />
                                        </div>
                                    </div>
                                </div>
                                <div className="right_s">
                                    {selected.length > 0 && (
                                        <>
                                            <Button className="btn " variant="outlined" onClick={() => setOpen1(true)}>
                                                Bulk Suspend
                                            </Button>
                                            <Button
                                                className="btn "
                                                variant="outlined"
                                                onClick={() => setOpenNotify(true)}
                                            >
                                                Bulk Notify
                                            </Button>
                                        </>
                                    )}
                                    <Button className="btn " variant="outlined"><GetAppIcon />Export</Button>
                                    <Button className="btn " variant="outlined"><IosShareIcon />Import</Button>
                                    <Button className="btn btn_primary" onClick={() => navigate("add")}><AddIcon />Add Service Provider</Button>
                                </div>

                            </div>



                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {serviceProviderColumns.map((col, i) => (
                                                <TableCell key={i}>
                                                    {col === "Select" ? (
                                                        <Checkbox
                                                            checked={serviceProviderData.length > 0 && selected.length === serviceProviderData.length}
                                                            indeterminate={selected.length > 0 && selected.length < serviceProviderData.length}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setSelected(serviceProviderData.map((v) => v.id));
                                                                } else {
                                                                    setSelected([]);
                                                                }
                                                            }}
                                                        />
                                                    ) : (
                                                        col
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {serviceProviderData.map((provider, index) => (
                                            <TableRow key={provider.id} hover>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={selected.includes(provider.id)}
                                                        onChange={() => toggleSelect(provider.id)}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <b>{provider.name}</b><br />
                                                    <small>{provider.id}</small>
                                                </TableCell>

                                                <TableCell>
                                                    {provider.email}<br />
                                                    <small>{provider.phone}</small>
                                                </TableCell>

                                                <TableCell>{provider.type}</TableCell>

                                                <TableCell>
                                                    <span className="status_chip active">
                                                        {provider.status.toLowerCase()}
                                                    </span>
                                                </TableCell>

                                                <TableCell>
                                                    <HealthBar
                                                        value={provider.health}
                                                        onClick={() => {
                                                            setSelectedProviderForHealth(provider);
                                                            setOpenHealthModal(true);
                                                        }}
                                                    />
                                                </TableCell>


                                                <TableCell>{provider.revenue}</TableCell>

                                                <TableCell>
                                                    <SwitchToggle
                                                        checked={!provider.suspended}
                                                        onChange={() => {
                                                            const updated = [...serviceProviderData];
                                                            updated[index].suspended = !updated[index].suspended;
                                                            setServiceProviderData(updated);
                                                        }}
                                                    />
                                                </TableCell>

                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <IconButton onClick={() => navigate("/manage-service-providers/view")}>
                                                            <img src="/static/images/eye_icon.svg" />
                                                        </IconButton>
                                                        <IconButton>
                                                            <img src="/static/images/edit2_icon.svg" />
                                                        </IconButton>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
                <div className="main_title">
                    <h1>Service Provider Applications</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Service Provider Applications
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* TOTAL PURCHASES */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                16
                                <p>Total Applications</p>
                            </h2>
                            <figure className="active_order">
                                <PersonAddAltIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>All time</span>
                        </div>
                    </a>

                    {/* COMPLETED */}


                    {/* APPROVED */}
                    <a href="/manage-customers?filter=approved" className="cards">
                        <div className="data_top">
                            <h2>
                                4
                                <p>Approved</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>✔ Approved</span>
                        </div>
                    </a>

                    {/* REJECTED */}
                    <a href="/manage-customers?filter=rejected" className="cards">
                        <div className="data_top">
                            <h2>
                                2
                                <p>Rejected</p>
                            </h2>
                            <figure className="danger">
                                <BlockIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>✖ Rejected</span>
                        </div>
                    </a>

                </div>

                <div className="table_flex mt_20">
                    <div className="lt">
                        {selected.length > 0 && (
                            <div className="bulk_action_bar">
                                <span>{selected.length} selected</span>

                                <Button color="success">Approve selected</Button>
                                <Button color="error">Reject selected</Button>
                            </div>
                        )}
                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search SPs..."
                                        />
                                    </Box>
                                    <div className=" form">
                                        <div className="control_group">
                                            <input type="date" />
                                        </div>
                                        <Select value="Pending" size="small" fullWidth >
                                            <MenuItem value="Pending">All Status</MenuItem>
                                            <MenuItem value="Accepted">Submitted</MenuItem>
                                            <MenuItem value="Rejected">Under Review</MenuItem>
                                            <MenuItem value="Rejected">Approved</MenuItem>
                                            <MenuItem value="Rejected">Rejected</MenuItem>
                                        </Select>
                                        <div className=" form">
                                            <Select
                                                multiple
                                                displayEmpty
                                                value={visibleApplicationColumns}
                                                onChange={(e) =>
                                                    setVisibleApplicationColumns(e.target.value as string[])
                                                }
                                                size="small"
                                                renderValue={(selected) =>
                                                    selected.length === applicationColumns.length
                                                        ? "All Columns Selected"
                                                        : `${selected.length} columns visible`
                                                }
                                                sx={{ minWidth: 200 }}
                                            >
                                                {applicationColumns.map((col) => (
                                                    <MenuItem key={col} value={col}>
                                                        <Checkbox
                                                            checked={visibleApplicationColumns.includes(col)}
                                                        />
                                                        <ListItemText primary={col} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                </div>


                            </div>


                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {applicationColumns.map((col, i) => (
                                                <TableCell key={i}>
                                                    {col === "Select" ? (
                                                        <Checkbox
                                                            checked={serviceProviderApplicationData.length > 0 && selected.length === serviceProviderApplicationData.length}
                                                            indeterminate={selected.length > 0 && selected.length < serviceProviderApplicationData.length}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setSelected(serviceProviderApplicationData.map((v) => v.id));
                                                                } else {
                                                                    setSelected([]);
                                                                }
                                                            }}
                                                        />
                                                    ) : (
                                                        col
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {serviceProviderApplicationData.map((provider) => (
                                            <TableRow 
                                                key={provider.id} 
                                                hover 
                                                className="cr_pt"
                                                onClick={() => toggleExpand(provider.id)}
                                            >
                                                {/* SELECT */}
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={selected.includes(provider.id)}
                                                        onChange={() => toggleSelect(provider.id)}
                                                    />
                                                </TableCell>

                                                {/* BUSINESS */}
                                                <TableCell>
                                                    <div className="user_block">
                                                        <p>
                                                            <b>{provider.name}</b>
                                                            <span className="badge1 neutral" style={{ fontSize: "10px", marginTop: "4px" }}>
                                                                {provider.category}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </TableCell>

                                                {/* PROVIDER DETAILS */}
                                                <TableCell>
                                                    <div className="user_block">
                                                        <p>
                                                            <b>Contact HQ</b>
                                                            <span>{provider.email}</span>
                                                            <small className="vendor_id">{provider.id}</small>
                                                        </p>
                                                    </div>
                                                </TableCell>

                                                <TableCell>{provider.category}</TableCell>
                                                <TableCell>{provider.serviceType}</TableCell>

                                                {/* RISK */}
                                                <TableCell>
                                                    <span className={`risk ${provider.riskScore < 25 ? "low" : "high"}`}>
                                                        {provider.riskScore}%
                                                    </span>
                                                </TableCell>

                                                {/* QUALITY */}
                                                <TableCell>{provider.qualityScore}%</TableCell>

                                                {/* COMPLIANCE */}
                                                <TableCell>
                                                    {provider.complianceReady ? "✅ Ready" : "❌ Missing"}
                                                </TableCell>

                                                {/* REVENUE */}
                                                <TableCell>{provider.revenuePotential}</TableCell>

                                                {/* PENDING */}
                                                <TableCell>
                                                    <span className={`pending_chip ${provider.pendingDays > 7 ? "danger" : "warning"}`}>
                                                        {provider.pendingDays} Days
                                                    </span>
                                                </TableCell>

                                                {/* STATUS */}
                                                <TableCell>
                                                    <div className="form">
                                                        <Select value="Pending" size="small" fullWidth>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Accepted">Accept</MenuItem>
                                                            <MenuItem value="Rejected" onClick={() => setOpen1(true)}>Reject</MenuItem>
                                                        </Select>
                                                    </div>
                                                </TableCell>

                                                <TableCell>{provider.appliedOn}</TableCell>

                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <IconButton onClick={() => navigate("/manage-service-providers/view")}>
                                                            <img src="/static/images/eye_icon.svg" />
                                                        </IconButton>
                                                        <IconButton>
                                                            <img src="/static/images/trash2_icon.svg" />
                                                        </IconButton>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            <CustomTabPanel value={valueTabs1} index={2}>
                <div className="main_title">
                    <h1>Service Providers Performance</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  Service Providers Performance
                    </p>
                </div>
                <div className="stats_boxes gap_m onboarding_stats">
                    {/* Avg Health Score */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                88
                                <p>Avg Health Score</p>
                            </h2>
                            <figure className="info">
                                <FavoriteIcon />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>Out of 100</span>
                        </div>
                    </a>

                    {/* Total Orders */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                1,641
                                <p>Total Orders</p>
                            </h2>
                            <figure className="success">
                                <ShoppingCartIcon />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>+15% last month</span>
                        </div>
                    </a>

                    {/* Avg Rating */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                0.0
                                <p>Avg Rating</p>
                            </h2>
                            <figure className="warning">
                                <StarIcon />
                            </figure>
                        </div>

                        <div className="ai_insight neutral">
                            <span>Out of 5</span>
                        </div>
                    </a>

                    {/* Total Revenue */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                AED 0
                                <p>Total Revenue</p>
                            </h2>
                            <figure className="orange">
                                <CurrencyExchangeIcon />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>+0% last month</span>
                        </div>
                    </a>
                </div>
                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search..."
                                        />
                                    </Box>
                                    <div className="form">
                                        <div className="control_group">
                                            <input type="date" />
                                        </div>
                                    </div>
                                </div>
                                <div className="right_s">

                                </div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {performanceColumns.map((col, i) => (
                                                <TableCell key={i}>{col}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {serviceProviderPerformanceData.map((provider) => (
                                            <TableRow key={provider.id} hover>
                                                {/* Provider Details */}
                                                <TableCell>
                                                    <div className="user_block">
                                                        <p>
                                                            <b>{provider.name}</b>
                                                            <small className="vendor_id">{provider.id}</small>
                                                        </p>
                                                    </div>
                                                </TableCell>

                                                {/* Business Details */}
                                                <TableCell>
                                                    <div className="user_block">
                                                        <p>
                                                            <b>Contact HQ</b>
                                                            <span>{provider.email}</span>
                                                        </p>
                                                    </div>
                                                </TableCell>

                                                {/* Period */}
                                                <TableCell>
                                                    {provider.periodStart} – {provider.periodEnd}
                                                </TableCell>

                                                {/* Service Requests */}
                                                <TableCell>{provider.totalJobs}</TableCell>

                                                {/* Completed */}
                                                <TableCell>
                                                    <Tooltip
                                                        title={
                                                            <Box sx={{ p: 1 }}>
                                                                <Typography variant="subtitle2" mb={1}>
                                                                    Completion Breakdown
                                                                </Typography>
                                                                <Typography variant="caption" display="block" sx={{ color: "#4caf50" }}>
                                                                    Delivered: {provider.performanceBreakdown?.completed.delivered}
                                                                </Typography>
                                                                <Typography variant="caption" display="block" sx={{ color: "#f44336" }}>
                                                                    Cancelled: {provider.performanceBreakdown?.completed.cancelled}
                                                                </Typography>
                                                                <Typography variant="caption" display="block" sx={{ color: "#ff9800" }}>
                                                                    Returned: {provider.performanceBreakdown?.completed.returned}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        arrow
                                                    >
                                                        <span>{provider.completedJobs}/{provider.totalJobs}</span>
                                                    </Tooltip>
                                                </TableCell>

                                                {/* GMV */}
                                                <TableCell>
                                                    <Tooltip
                                                        title={
                                                            <Box sx={{ p: 1 }}>
                                                                <Typography variant="subtitle2" mb={1}>
                                                                    GMV Breakdown
                                                                </Typography>
                                                                <Typography variant="caption" display="block">
                                                                    Services: {provider.performanceBreakdown?.gmv.products}
                                                                </Typography>
                                                                <Typography variant="caption" display="block">
                                                                    Extras/Fees: {provider.performanceBreakdown?.gmv.shipping}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        arrow
                                                    >
                                                        <span>{provider.gmv}</span>
                                                    </Tooltip>
                                                </TableCell>

                                                {/* Commission */}
                                                <TableCell>
                                                    <Tooltip
                                                        title={
                                                            <Box sx={{ p: 1 }}>
                                                                <Typography variant="subtitle2" mb={1}>
                                                                    Commission Details
                                                                </Typography>
                                                                <Typography variant="caption" display="block">
                                                                    Base: {provider.performanceBreakdown?.commission.base}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        arrow
                                                    >
                                                        <span>{provider.commission}</span>
                                                    </Tooltip>
                                                </TableCell>

                                                {/* Net to Provider */}
                                                <TableCell>
                                                    <Tooltip
                                                        title={
                                                            <Box sx={{ p: 1 }}>
                                                                <Typography variant="subtitle2" mb={1}>
                                                                    Net Calculation
                                                                </Typography>
                                                                <Typography variant="caption" display="block" sx={{ color: "#4caf50" }}>
                                                                    GMV: {provider.gmv}
                                                                </Typography>
                                                                <Typography variant="caption" display="block" sx={{ color: "#f44336" }}>
                                                                    Fees: -{provider.commission}
                                                                </Typography>
                                                                <hr style={{ margin: "4px 0", borderColor: "rgba(255,255,255,0.1)" }} />
                                                                <Typography variant="caption" display="block">
                                                                    <b>Payable: {provider.netToProvider}</b>
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        arrow
                                                    >
                                                        <span>{provider.netToProvider}</span>
                                                    </Tooltip>
                                                </TableCell>

                                                {/* Revenue */}
                                                <TableCell>
                                                    <Tooltip
                                                        title={
                                                            <Box sx={{ p: 1 }}>
                                                                <Typography variant="subtitle2" mb={1}>
                                                                    Platform Revenue
                                                                </Typography>
                                                                <Typography variant="caption" display="block">
                                                                    Commission: {provider.performanceBreakdown?.revenue.base}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        arrow
                                                    >
                                                        <span>{provider.revenue}</span>
                                                    </Tooltip>
                                                </TableCell>

                                                {/* Rating */}
                                                <TableCell>
                                                    ⭐ {provider.rating}
                                                </TableCell>

                                                {/* On-Time % */}
                                                <TableCell>
                                                    <Tooltip
                                                        title={
                                                            <Box sx={{ p: 1 }}>
                                                                <Typography variant="subtitle2" mb={1}>
                                                                    Service Performance
                                                                </Typography>
                                                                <Typography variant="caption" display="block" sx={{ color: "#4caf50" }}>
                                                                    Early: {provider.performanceBreakdown?.onTime.early}
                                                                </Typography>
                                                                <Typography variant="caption" display="block">
                                                                    On-Time: {provider.performanceBreakdown?.onTime.justInTime}
                                                                </Typography>
                                                                <Typography variant="caption" display="block" sx={{ color: "#f44336" }}>
                                                                    Delayed: {provider.performanceBreakdown?.onTime.delayed}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        arrow
                                                    >
                                                        <span
                                                            className={`ontime ${provider.onTime >= 90 ? "good" : "avg"}`}
                                                        >
                                                            {provider.onTime}%
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>

                                                {/* Health */}
                                                <TableCell>
                                                    <HealthBar
                                                        value={provider.health}
                                                        onClick={() => {
                                                            setSelectedProviderForHealth(provider);
                                                            setOpenHealthModal(true);
                                                        }}
                                                    />
                                                    <small>{provider.health}</small>
                                                </TableCell>

                                                {/* AI Insights */}
                                                <TableCell>
                                                    {provider.aiInsight && (
                                                        <Tooltip title={provider.aiInsight} arrow>
                                                            <IconButton size="small">
                                                                <SmartToyOutlinedIcon color="primary" fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </TableCell>

                                                {/* Actions */}
                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <IconButton
                                                            onClick={() =>
                                                                navigate("/manage-service-providers/view")
                                                            }
                                                        >
                                                            <img src="/static/images/eye_icon.svg" />
                                                        </IconButton>
                                                        <IconButton>
                                                            <img src="/static/images/edit2_icon.svg" />
                                                        </IconButton>
                                                        {(provider as any).aiRecommendation && (
                                                            <Tooltip
                                                                title={
                                                                    <Box sx={{ p: 1 }}>
                                                                        <Typography variant="subtitle2">AI Recommendation</Typography>
                                                                        <Typography variant="body2">Action: {(provider as any).aiRecommendation.action}</Typography>
                                                                        <Typography variant="caption" display="block">Reason: {(provider as any).aiRecommendation.reason}</Typography>
                                                                    </Box>
                                                                }
                                                                arrow
                                                            >
                                                                <IconButton size="small">
                                                                    <TrendingUpIcon color="secondary" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>

                </div>


            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
                <div className="main_title">
                    <h1>Service Provider Services</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Services
                    </p>
                </div>

                <div className="stats_boxes gap_m">

                    <div className="cards service_card">
                        <div className="data_top">
                            <h2>18<p>Total Services</p></h2>
                            <figure className="blue">🛠️</figure>
                        </div>
                        <div className="ai_insight info">
                            <span>All listed services</span>
                        </div>
                    </div>

                    <div className="cards service_card">
                        <div className="data_top">
                            <h2>12<p>Active Services</p></h2>
                            <figure className="success">✅</figure>
                        </div>
                        <div className="ai_insight positive">
                            <span>Accepting bookings</span>
                        </div>
                    </div>

                    <div className="cards service_card">
                        <div className="data_top">
                            <h2>4<p>Pending Approval</p></h2>
                            <figure className="warning">⏳</figure>
                        </div>
                        <div className="ai_insight warning">
                            <span>Under review</span>
                        </div>
                    </div>

                    <div className="cards service_card">
                        <div className="data_top">
                            <h2>2<p>Inactive</p></h2>
                            <figure className="danger">⛔</figure>
                        </div>
                        <div className="ai_insight negative">
                            <span>Not bookable</span>
                        </div>
                    </div>

                </div>




                <div className="cards mt_20">
                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search services..."
                                />
                            </Box>
                            <div className="form">
                                <div className="control_group">
                                    <input type="date" />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="table_flex">
                        <div className="lt">
                            <div className="services_grid">
                                {serviceData.map((service, index) => (
                                    <div className="service_card ai_enhanced" key={index}>
                                        {/* Header */}
                                        <div className="card_header">
                                            <Box>
                                                <h3>{service.name}</h3>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <span
                                                        className={`health_indicator ${service.healthScore >= 80 ? 'healthy' : service.healthScore >= 60 ? 'attention' : 'risk'}`}
                                                    ></span>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', fontSize: '10px' }}>
                                                        {service.healthScore >= 80 ? 'Healthy' : service.healthScore >= 60 ? 'Attention' : 'Risk'} • {service.healthScore}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Select
                                                size="small"
                                                value={service.status}
                                                className={`status_select ${service.status.toLowerCase().replace(' ', '_')}`}
                                                onChange={() => {
                                                    setSelectedServiceForImpact(service);
                                                    setImpactModalOpen(true);
                                                }}
                                            >
                                                <MenuItem value="Active">Active</MenuItem>
                                                <MenuItem value="Inactive">Inactive</MenuItem>
                                                <MenuItem value="Pending Approval">Pending Approval</MenuItem>
                                            </Select>
                                        </div>


                                        {/* Meta */}
                                        <div className="card_meta">
                                            <span className="category">{service.category}</span>
                                            <span className="dot">•</span>
                                            <span>{service.subCategory}</span>
                                        </div>

                                        {/* Details Grid */}
                                        <div className="card_details">
                                            <div className="detail_item">
                                                <p>Price Point</p>
                                                <Box display="flex" alignItems="baseline" gap={0.5}>
                                                    <h4 style={{ color: '#2563eb' }}>{service.price}</h4>
                                                    <small style={{ fontSize: '10px', color: '#94a3b8', fontWeight: 700 }}>AED</small>
                                                </Box>
                                            </div>
                                            <div className="detail_item">
                                                <p>Avg Duration</p>
                                                <h4>{service.duration}</h4>
                                            </div>
                                        </div>

                                        {/* Alert Flag */}
                                        {service.alert && (
                                            <div className="alert_flag">
                                                <WarningIcon sx={{ fontSize: 14 }} />
                                                <span style={{ fontSize: '11px' }}>{service.alert}</span>
                                            </div>
                                        )}

                                        {/* Footer Stats */}
                                        <div className="card_footer">
                                            <div className="bookings">
                                                <p>Total Bookings</p>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <h4>{service.bookings}</h4>
                                                    {service.trend && (
                                                        <div className={`trend_tag ${service.trend.direction}`}>
                                                            {service.trend.direction === 'up' ? <TrendingUpIcon sx={{ fontSize: 12 }} /> : <TrendingDownIcon sx={{ fontSize: 12 }} />}
                                                            <span>{service.trend.value}%</span>
                                                        </div>
                                                    )}
                                                </Box>
                                            </div>
                                            <div className="benchmark">
                                                <p>Benchmark</p>
                                                <span>{service.benchmark}</span>
                                            </div>
                                        </div>

                                        {/* Inactive Recovery / Pending Auto-Decision */}
                                        {service.status === 'Inactive' && (
                                            <div className="recovery_section">
                                                <h5>Recovery Suggestion</h5>
                                                <Button fullWidth size="small" variant="outlined" sx={{ textTransform: 'none', fontSize: '11px', borderRadius: '8px' }}>
                                                    Optimize Metadata & Re-activate
                                                </Button>
                                            </div>
                                        )}

                                        {service.status === 'Pending Approval' && (
                                            <Box className="recovery_section">
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '10px' }}>AI RISK LEVEL:</Typography>
                                                    <Chip
                                                        label={service.riskLevel}
                                                        size="small"
                                                        color={service.riskLevel === 'Low' ? 'success' : service.riskLevel === 'Medium' ? 'warning' : 'error'}
                                                        sx={{ height: 18, fontSize: 10, fontWeight: 700 }}
                                                    />
                                                </Box>
                                                <Box display="flex" gap={1}>
                                                    <Button variant="contained" size="small" fullWidth sx={{ fontSize: 10, bgcolor: '#22c55e', textTransform: 'none' }}>Approve</Button>
                                                    <Button variant="outlined" size="small" fullWidth sx={{ fontSize: 10, textTransform: 'none' }}>Review</Button>
                                                </Box>
                                            </Box>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="rt">
                            <div className="ai_panel">
                                <h4>AI Insights</h4>

                                <div className="ai_alert warning">
                                    <span className="icon">⚠️</span>
                                    <p>
                                        <b>7 SKUs</b> need immediate attention
                                    </p>
                                </div>

                                <div className="ai_alert danger">
                                    <span className="icon">⛔</span>
                                    <p>
                                        <b>3 SKUs</b> have zero sales in 30 days
                                    </p>
                                </div>

                                <small className="ai_update">
                                    Next updated ETA: <b>May 5, 2024</b>
                                </small>

                                <div className="ai_sku_list">
                                    {serviceData.filter(s => s.recommendation || s.priceInsight).map((service, idx) => (
                                        <div className="ai_sku_row" key={idx}>
                                            <div className="ai_sku_info">
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <h5 style={{ margin: 0 }}>{service.name}</h5>
                                                    {service.recommendation && (
                                                        <span className={`status_pill ${service.recommendation.type}`} style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '10px' }}>
                                                            {service.recommendation.label}</span>
                                                    )}
                                                </Box>
                                                {service.recommendation && <p style={{ margin: '4px 0 0 0', fontSize: '12px' }}>{service.recommendation.insight}</p>}
                                                {service.priceInsight && (
                                                    <p style={{ margin: '4px 0 0 0', fontSize: '11px', color: '#64748b' }}>
                                                        <LightbulbIcon sx={{ fontSize: 12, verticalAlign: 'middle', mr: 0.5 }} />
                                                        {service.priceInsight.text}
                                                    </p>
                                                )}
                                            </div>
                                            <button className="ai_action_btn">View ▾</button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={4}>
                <div className="main_title">
                    <h1>Service Provider Payouts</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Service Provider Payouts
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* TOTAL PAYOUTS */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                AED 1161032.35
                                <p>Total Payouts</p>
                            </h2>
                            <figure className="blue">
                                $
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>All time payouts</span>
                        </div>
                    </a>

                    {/* PENDING AMOUNT */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                AED 257629.94
                                <p>Pending Amount</p>
                            </h2>
                            <figure className="warning">
                                ⏰
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>Awaiting processing</span>
                        </div>
                    </a>

                    {/* COMPLETED */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                11
                                <p>Completed</p>
                            </h2>
                            <figure className="success">
                                ✔
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>Successful payouts</span>
                        </div>
                    </a>

                    {/* PROCESSING */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                3
                                <p>Processing</p>
                            </h2>
                            <figure className="info">
                                ↗
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>In progress</span>
                        </div>
                    </a>
                </div>
                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search SPs..."
                                        />
                                    </Box>
                                    <div className=" form">
                                        <div className="control_group">
                                            <input type="date" />
                                        </div>
                                        <Select value="Pending" size="small" fullWidth >
                                            <MenuItem value="Pending">All Status</MenuItem>
                                            <MenuItem value="Accepted">Pending</MenuItem>
                                            <MenuItem value="Rejected">Completed</MenuItem>
                                            <MenuItem value="Rejected">Processing</MenuItem>
                                            <MenuItem value="Rejected">Failed</MenuItem>
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {payoutColumns.map((col, i) => (
                                                <TableCell key={i}>{col}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {payoutData.map((item) => (
                                            <TableRow key={item.id} hover>

                                                {/* Payout ID */}
                                                <TableCell>
                                                    <b>{item.id}</b><br />
                                                    <small>{item.method}</small>
                                                </TableCell>

                                                {/* Vendor */}
                                                <TableCell>{item.vendor}</TableCell>

                                                {/* Period */}
                                                <TableCell>{item.period}</TableCell>

                                                {/* Orders */}
                                                <TableCell>{item.orders}</TableCell>

                                                {/* Gross Sales */}
                                                <TableCell>AED {item.gross}</TableCell>

                                                {/* Commission */}
                                                <TableCell className="danger">
                                                    -AED {item.commission}
                                                </TableCell>

                                                {/* Net Amount */}
                                                <TableCell>
                                                    <b>AED {item.net}</b>
                                                </TableCell>

                                                {/* Status */}
                                                <TableCell>
                                                    <span
                                                        className={`status_chip ${item.status === "Completed" ? "success" : "warning"
                                                            }`}
                                                    >
                                                        {item.status}
                                                    </span>
                                                </TableCell>

                                                {/* Actions */}
                                                <TableCell>
                                                    {item.status === "Pending" ? (
                                                        <Button className="btn btn_primary sm">Process</Button>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>

            </CustomTabPanel>

            <CustomTabPanel value={valueTabs1} index={5}>
                <div className="main_title">
                    <h1>Service Provider Analytics</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Service Provider Analytics
                    </p>
                </div>


                <div className="stats_boxes gap_m">
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                25
                                <p>Total Service Provider</p>
                            </h2>
                            <figure className="blue">
                                <GpsFixedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>12.5% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                21
                                <p>Active Service Provider</p>
                            </h2>
                            <figure className="success">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>8.3% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                172,230.00 AED
                                <p>Total Revenue</p>
                            </h2>
                            <figure className="warning">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>15.2% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                6,889.20 AED
                                <p>Avg Customer LTV</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>6.7% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                711.69 AED
                                <p>Avg Order Value</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>2.1% decrease</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                3
                                <p>New Service Provider (30d)</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>22.4% increase</span>
                        </div>
                    </a>
                </div>
                <div className="stats_boxes gap_m mt_20">
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                84%
                                <p>Active Capacity (%)</p>
                            </h2>
                            <figure className="blue">
                                <AssessmentOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>% of providers currently accepting bookings</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                5
                                <p>Overloaded Providers</p>
                            </h2>
                            <figure className="warning">
                                <WarningIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>Providers with &gt;80% booking utilization</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                3
                                <p>Underutilized Providers</p>
                            </h2>
                            <figure className="purple">
                                <TrendingDownIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>Active but &lt;30% booking utilization</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                2.4 Days
                                <p>Avg Booking Lead Time</p>
                            </h2>
                            <figure className="info">
                                <InfoIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>Time from booking &rarr; service date</span>
                        </div>
                    </a>
                </div>

                {/* Quality KPIs section */}
                <div className="main_title mt_20">
                    <h2 style={{ fontSize: '18px', fontWeight: 600 }}>Quality KPIs</h2>
                </div>
                <div className="stats_boxes gap_m mt_10">
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                4.8 / 5.0
                                <p>Avg Customer Rating</p>
                            </h2>
                            <figure className="sucess">
                                <StarIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span><ArrowUpwardIcon fontSize="inherit" /> 0.2</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                1.2%
                                <p>Cancellation Rate</p>
                            </h2>
                            <figure className="sucess">
                                <CancelIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span><ArrowDownwardIcon fontSize="inherit" /> 0.5%</span>
                            <small>lower is better</small>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                0.8%
                                <p>No-Show Rate</p>
                            </h2>
                            <figure className="sucess">
                                <PersonOffIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span><ArrowDownwardIcon fontSize="inherit" /> 0.2%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                1.5
                                <p>Complaint Rate (per 100)</p>
                            </h2>
                            <figure className="warning">
                                <ReportIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span><ArrowUpwardIcon fontSize="inherit" /> 0.3</span>
                            <small>risk of penalty</small>
                        </div>
                    </a>
                </div>

                <Grid container spacing={3} mt={1}>
                    {/* Performance Trends */}
                    <Grid item xs={12} md={8}>
                        <div className="cards h_100">
                            <div className="card_header_flex">
                                <h3>Revenue vs. Booking Trends</h3>
                                <Select size="small" defaultValue="6">
                                    <MenuItem value="3">Last 3 Months</MenuItem>
                                    <MenuItem value="6">Last 6 Months</MenuItem>
                                    <MenuItem value="12">Last 12 Months</MenuItem>
                                </Select>
                            </div>
                            <Box sx={{ height: 300, mt: 2 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <AreaChart data={[
                                        { month: 'Sep', revenue: 45000, bookings: 320 },
                                        { month: 'Oct', revenue: 52000, bookings: 380 },
                                        { month: 'Nov', revenue: 48000, bookings: 350 },
                                        { month: 'Dec', revenue: 61000, bookings: 420 },
                                        { month: 'Jan', revenue: 55000, bookings: 400 },
                                        { month: 'Feb', revenue: 68000, bookings: 450 },
                                    ]}>
                                        <defs>
                                            <linearGradient id="colorRev" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#2563eb" stopOpacity={0.1} />
                                                <stop offset="95%" stopColor="#2563eb" stopOpacity={0} />
                                            </linearGradient>
                                        </defs>
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                                        <XAxis dataKey="month" fontSize={12} axisLine={false} tickLine={false} />
                                        <YAxis yAxisId="left" fontSize={12} axisLine={false} tickLine={false} />
                                        <YAxis yAxisId="right" orientation="right" fontSize={12} axisLine={false} tickLine={false} />
                                        <RechartsTooltip />
                                        <Legend verticalAlign="top" height={36} />
                                        <Area yAxisId="left" type="monotone" dataKey="revenue" name="Revenue (AED)" stroke="#2563eb" fillOpacity={1} fill="url(#colorRev)" strokeWidth={2} />
                                        <Line yAxisId="right" type="monotone" dataKey="bookings" name="Bookings" stroke="#f59e0b" strokeWidth={2} dot={{ r: 4 }} />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </Box>
                        </div>
                    </Grid>

                    {/* Category Distribution */}
                    <Grid item xs={12} md={4}>
                        <div className="cards h_100">
                            <h3>Revenue by Category</h3>
                            <Box sx={{ height: 300, mt: 2, position: 'relative' }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <PieChart>
                                        <Pie
                                            data={[
                                                { name: 'Cleaning', value: 35, color: '#2563eb' },
                                                { name: 'Beauty', value: 25, color: '#22c55e' },
                                                { name: 'Repair', value: 20, color: '#f59e0b' },
                                                { name: 'Fitness', value: 15, color: '#ef4444' },
                                                { name: 'Others', value: 5, color: '#64748b' },
                                            ]}
                                            cx="50%"
                                            cy="50%"
                                            innerRadius={60}
                                            outerRadius={80}
                                            paddingAngle={5}
                                            dataKey="value"
                                        >
                                            {[
                                                { color: '#2563eb' },
                                                { color: '#22c55e' },
                                                { color: '#f59e0b' },
                                                { color: '#ef4444' },
                                                { color: '#64748b' },
                                            ].map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={entry.color} />
                                            ))}
                                        </Pie>
                                        <RechartsTooltip />
                                        <Legend layout="vertical" align="right" verticalAlign="middle" />
                                    </PieChart>
                                </ResponsiveContainer>
                                <Box sx={{ position: 'absolute', top: '50%', left: '35%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 700 }}>100%</Typography>
                                    <Typography variant="caption" color="text.secondary">Total</Typography>
                                </Box>
                            </Box>
                        </div>
                    </Grid>
                </Grid>

                <Grid container spacing={3} mt={1}>
                    {/* Health Score Distribution */}
                    <Grid item xs={12} md={4}>
                        <div className="cards h_100">
                            <h3>Health Score Distribution</h3>
                            <Box sx={{ height: 250, mt: 2 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <PieChart>
                                        <Pie
                                            data={[
                                                { name: 'Excellent (90-100)', value: 12, color: '#22c55e' },
                                                { name: 'Good (75-89)', value: 8, color: '#2563eb' },
                                                { name: 'At Risk (60-74)', value: 4, color: '#f59e0b' },
                                                { name: 'Critical (<60)', value: 1, color: '#ef4444' },
                                            ]}
                                            innerRadius={60}
                                            outerRadius={80}
                                            paddingAngle={5}
                                            dataKey="value"
                                        >
                                            {[
                                                { color: '#22c55e' },
                                                { color: '#2563eb' },
                                                { color: '#f59e0b' },
                                                { color: '#ef4444' },
                                            ].map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={entry.color} />
                                            ))}
                                        </Pie>
                                        <RechartsTooltip />
                                        <Legend verticalAlign="bottom" align="center" wrapperStyle={{ fontSize: '10px' }} />
                                    </PieChart>
                                </ResponsiveContainer>
                            </Box>
                        </div>
                    </Grid>

                    {/* Top Providers */}
                    <Grid item xs={12} md={4}>
                        <div className="cards h_100">
                            <h3>Top 5 Providers</h3>
                            <Box sx={{ height: 250, mt: 2 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart data={[
                                        { name: 'PixelCraft', rev: 42000 },
                                        { name: 'DesignSphere', rev: 38500 },
                                        { name: 'MotionHive', rev: 35000 },
                                        { name: 'CleanPros', rev: 31000 },
                                        { name: 'BeautyBox', rev: 28000 },
                                    ]} layout="vertical">
                                        <XAxis type="number" hide />
                                        <YAxis dataKey="name" type="category" fontSize={10} width={80} axisLine={false} tickLine={false} />
                                        <RechartsTooltip cursor={{ fill: 'transparent' }} />
                                        <Bar dataKey="rev" fill="#2563eb" radius={[0, 4, 4, 0]} barSize={15} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </Box>
                        </div>
                    </Grid>

                    {/* Fulfillment Rate Trend */}
                    <Grid item xs={12} md={4}>
                        <div className="cards h_100">
                            <h3>Category Efficiency</h3>
                            <Box sx={{ height: 250, mt: 2 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart data={[
                                        { cat: 'Cleaning', rate: 94 },
                                        { cat: 'Repair', rate: 88 },
                                        { cat: 'Beauty', rate: 96 },
                                        { cat: 'Fitness', rate: 82 },
                                    ]}>
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                                        <XAxis dataKey="cat" fontSize={10} axisLine={false} tickLine={false} />
                                        <YAxis fontSize={10} axisLine={false} tickLine={false} domain={[0, 100]} />
                                        <RechartsTooltip />
                                        <Bar dataKey="rate" radius={[4, 4, 0, 0]} barSize={30}>
                                            {[
                                                { rate: 94 },
                                                { rate: 88 },
                                                { rate: 96 },
                                                { rate: 82 },
                                            ].map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={entry.rate > 90 ? '#22c55e' : '#f59e0b'} />
                                            ))}
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </Box>
                        </div>
                    </Grid>
                </Grid>

                {/* Service Category Performance */}
                <div className="cards mt_20">
                    <h3>Service Category Performance</h3>
                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search SPs..."
                                />
                            </Box>
                            <div className="form">
                                <Select value="Pending" size="small" fullWidth >
                                    <MenuItem value="Pending">All Categories</MenuItem>
                                    <MenuItem value="Accepted">Category 1</MenuItem>
                                    <MenuItem value="Rejected">Category 2</MenuItem>
                                    <MenuItem value="Rejected">Category 3</MenuItem>
                                    <MenuItem value="Rejected">Category 4</MenuItem>
                                </Select>
                            </div>
                        </div>


                    </div>
                    <TableContainer className="table_container mt_10">
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Category</TableCell>
                                    <TableCell>Active Providers</TableCell>
                                    <TableCell>Total Bookings</TableCell>
                                    <TableCell>Avg Rating</TableCell>
                                    <TableCell>Revenue (AED)</TableCell>
                                    <TableCell>Fulfillment Rate</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {[
                                    { cat: 'Cleaning', p: 12, b: 1540, r: 4.8, rev: '85,400', f: '94%' },
                                    { cat: 'Appliance Repair', p: 8, b: 620, r: 4.4, rev: '42,100', f: '88%' },
                                    { cat: 'Beauty', p: 15, b: 1200, r: 4.9, rev: '64,000', f: '96%' },
                                    { cat: 'Fitness', p: 5, b: 300, r: 4.2, rev: '28,500', f: '82%' },
                                ].map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell><b>{row.cat}</b></TableCell>
                                        <TableCell>{row.p}</TableCell>
                                        <TableCell>{row.b}</TableCell>
                                        <TableCell>⭐ {row.r}</TableCell>
                                        <TableCell>{row.rev}</TableCell>
                                        <TableCell>
                                            <span style={{ color: parseInt(row.f) > 90 ? '#22c55e' : '#f59e0b' }}>{row.f}</span>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                {/* AI Insights & Risk Watchlist */}
                <Grid container spacing={3} mt={2}>
                    <Grid item xs={12} md={7}>
                        <div className="cards h_100">
                            <Box display="flex" alignItems="center" gap={1} mb={2}>
                                <AutoFixHighOutlinedIcon color="primary" />
                                <h3>AI Insights & Recommendations</h3>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                {[
                                    { icon: <TrendingDownIcon />, color: 'error', text: '3 providers show declining on-time delivery for 2 weeks', action: 'Schedule Review', reason: 'High cancellations detected' },
                                    { icon: <TrendingUpIcon />, color: 'success', text: 'Cleaning services demand ↑ 22%, but provider count unchanged', action: 'Onboard New SPs', reason: 'Unmet demand in UAE region' },
                                    { icon: <HelpOutlineIcon />, color: 'warning', text: 'Fitness category has high ratings but low bookings — pricing mismatch likely', action: 'Adjust Benchmark', reason: 'Price 15% above market median' },
                                ].map((insight, i) => (
                                    <Paper key={i} variant="outlined" sx={{ p: 2, bgcolor: '#f8fafc' }}>
                                        <Box display="flex" gap={2}>
                                            <Box sx={{ p: 1, borderRadius: 1, bgcolor: '#fff', color: `${insight.color}.main`, display: 'flex', alignItems: 'center', height: 'fit-content' }}>
                                                {insight.icon}
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <Typography variant="body2" sx={{ fontWeight: 600 }}>{insight.text}</Typography>
                                                <Typography variant="caption" sx={{ color: '#64748b', display: 'block', mt: 0.5 }}>
                                                    <strong>Reason:</strong> {insight.reason}
                                                </Typography>
                                                <Button size="small" sx={{ mt: 1, textTransform: 'none' }}>{insight.action}</Button>
                                            </Box>
                                        </Box>
                                    </Paper>
                                ))}
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <div className="cards h_100">
                            <Box display="flex" alignItems="center" gap={1} mb={2}>
                                <WarningIcon color="error" />
                                <h3>Provider Risk Watchlist</h3>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {[
                                    { name: 'MotionHive', risk: 'High', reason: 'Health score ↓ / High cancellations', color: '#ef4444' },
                                    { name: 'PixelCraft', risk: 'Medium', reason: 'Rising complaints (3 in 7 days)', color: '#f59e0b' },
                                    { name: 'DesignSphere', risk: 'Medium', reason: 'Missed SLAs on 3 bookings', color: '#f59e0b' },
                                ].map((item, i) => (
                                    <Box key={i} display="flex" justifyContent="space-between" alignItems="center" p={1.5} sx={{ border: '1px solid #e2e8f0', borderRadius: 1 }}>
                                        <Box>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.name}</Typography>
                                            <Typography variant="caption" sx={{ color: '#64748b' }}>{item.reason}</Typography>
                                        </Box>
                                        <Box textAlign="right">
                                            <Chip label={item.risk} size="small" sx={{ bgcolor: item.color, color: '#fff', fontWeight: 600, height: 20, fontSize: 10, mb: 0.5 }} />
                                            <Box display="flex" gap={1}>
                                                <Typography variant="caption" sx={{ color: '#2563eb', cursor: 'pointer' }}>View Profile</Typography>
                                                <Typography variant="caption" sx={{ color: '#ef4444', cursor: 'pointer' }}>Send Warning</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                                <Button variant="outlined" fullWidth sx={{ mt: 1 }}>View All Risks</Button>
                            </Box>
                        </div>
                    </Grid>
                </Grid>


            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={6}>
                <div className="main_title d_flex">
                    <div className="left_s">
                        <h1>Bulk Export Service Providers</h1>
                        <p>
                            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                            Bulk Export Service Providers
                        </p>
                    </div>
                </div>
                <div className="stats_boxes gap_m">
                    {/* NEW SERVICE PROVIDERS */}
                    <a href="/manage-customers?filter=new" className="cards">
                        <div className="data_top">
                            <h2>
                                56
                                <p>New Service Providers</p>
                            </h2>
                            <figure className="active_order">
                                <PersonAddAltIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>▲ +12%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* ACTIVE SERVICE PROVIDERS */}
                    <a href="/manage-customers?filter=active" className="cards">
                        <div className="data_top">
                            <h2>
                                1,120
                                <p>Active Service Providers</p>
                            </h2>
                            <figure className="sucess">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>84.0%</span>
                            <small>of total providers</small>
                        </div>
                    </a>

                    {/* INACTIVE SERVICE PROVIDERS */}
                    <a href="/manage-customers?filter=inactive" className="cards">
                        <div className="data_top">
                            <h2>
                                125
                                <p>Inactive Service Providers</p>
                            </h2>
                            <figure className="danger">
                                <BlockIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>▼ -6%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* PENDING APPROVAL */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                92
                                <p>Pending Approval</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>▲ +8%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* TOTAL SERVICE PROVIDERS */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                1,301
                                <p>Total Service Providers</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>100%</span>
                            <small>provider base</small>
                        </div>
                    </a>
                </div>

                <div className="cards mt_20">
                    <div className="table_header table_header_bulk form">
                        <h4>Enter Date Range -</h4>
                        <input type="date" />
                        <input type="date" />
                        <Select
                            fullWidth
                            size="small"
                            multiple
                            displayEmpty
                            value={selectedExportFields}
                            onChange={(e) => setSelectedExportFields(e.target.value as string[])}
                            renderValue={(selected) =>
                                selected.length === 0
                                    ? "Select Fields To Export"
                                    : selected.join(", ")
                            }
                        >
                            {exportFields.map((field) => (
                                <MenuItem key={field} value={field}>
                                    <Checkbox checked={selectedExportFields.indexOf(field) > -1} />
                                    <ListItemText primary={field} />
                                </MenuItem>
                            ))}
                        </Select>
                        <Button className="btn btn_grey sm" variant="outlined">
                            <GetAppIcon />
                            Export
                        </Button>
                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {exportFields.map((col, i) => (
                                        <TableCell key={i}>{col}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {bulkSPExportData.map((provider) => (
                                    <TableRow key={provider.id} hover>
                                        <TableCell>
                                            <strong>{provider.providerName}</strong>
                                        </TableCell>
                                        <TableCell>{provider.businessName}</TableCell>
                                        <TableCell>{provider.category}</TableCell>
                                        <TableCell>{provider.serviceType}</TableCell>
                                        <TableCell>{provider.riskScore}</TableCell>
                                        <TableCell>{provider.qualityScore}</TableCell>
                                        <TableCell>{provider.compliance}</TableCell>
                                        <TableCell>{provider.revenuePotential}</TableCell>
                                        <TableCell>{provider.pendingDuration} days</TableCell>
                                        <TableCell>
                                            <span className={`status_chip ${provider.applicationStatus.toLowerCase()}`}>
                                                {provider.applicationStatus}
                                            </span>
                                        </TableCell>
                                        <TableCell>{provider.totalRequests}</TableCell>
                                        <TableCell>{provider.completedTasks}</TableCell>
                                        <TableCell>{provider.gmv}</TableCell>
                                        <TableCell>{provider.commission}</TableCell>
                                        <TableCell>{provider.netToProvider}</TableCell>
                                        <TableCell>{provider.revenue}</TableCell>
                                        <TableCell>⭐ {provider.rating}</TableCell>
                                        <TableCell>{provider.onTime}%</TableCell>
                                        <TableCell>
                                            <HealthBar value={provider.health} />
                                        </TableCell>
                                        <TableCell>
                                            <span className={`status_chip ${provider.status.toLowerCase()}`}>
                                                {provider.status}
                                            </span>
                                        </TableCell>
                                        <TableCell>{provider.onboardingDate}</TableCell>
                                        <TableCell>{provider.lastOrder}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </CustomTabPanel>
            <AIImpactModal
                open={impactModalOpen}
                onClose={() => setImpactModalOpen(false)}
                service={selectedServiceForImpact}
            />

            <LifecycleOverview open={open} onClose={handleCloseModal} setOpen={setOpen} />
            <RejectReasonModal open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
            <ViewSPHealthScores
                open={openHealthModal}
                onClose={() => setOpenHealthModal(false)}
                setOpen={setOpenHealthModal}
                provider={selectedProviderForHealth}
            />
            <BulkNotify open={openNotify} onClose={handleCloseNotify} setOpen={setOpenNotify} />

        </>
    );
};

const AIImpactModal = ({ open, onClose, service }: { open: boolean, onClose: () => void, service: any }) => {
    if (!service) return null;
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <AutoFixHighOutlinedIcon color="primary" />
                    <Typography variant="h6">AI Impact Analysis</Typography>
                </Box>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ mb: 3, p: 2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" color="primary" gutterBottom sx={{ fontWeight: 700 }}>
                        Service: {service.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Analyzing the impact of changing status to <strong>{service.status === 'Active' ? 'Inactive' : 'Active'}</strong>...
                    </Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
                            <Typography variant="h5" color="error" sx={{ fontWeight: 700 }}>
                                {service.impact?.revenue}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">Revenue Impact</Typography>
                            <Typography variant="body2" sx={{ mt: 1, display: 'block', fontSize: 10 }}>
                                This service generated {service.impact?.revenue} of provider’s revenue
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
                            <Typography variant="h5" color="warning.main" sx={{ fontWeight: 700 }}>
                                {service.impact?.bookings}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">Affected Bookings</Typography>
                            <Typography variant="body2" sx={{ mt: 1, display: 'block', fontSize: 10 }}>
                                {service.impact?.bookings} future bookings will be affected
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 3, p: 2, border: '1px solid #d3b88c', borderLeft: '4px solid #d3b88c', bgcolor: '#fffbeb' }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                        <LightbulbIcon sx={{ color: '#d3b88c', fontSize: 20 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Recommended Alternative:</Typography>
                    </Box>
                    <Typography variant="body2">
                        Pause new bookings instead of full deactivation to retain SEO ranking and customer favorites.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button variant="outlined" onClick={onClose} fullWidth>Cancel</Button>
                <Button variant="outlined" color="warning" fullWidth>Pause Bookings</Button>
                <Button variant="contained" color="error" fullWidth onClick={onClose}>Proceed</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ManageServiceProviders;
